import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import FeatureDrawer from '../helpers/FeatureDrawer';
import MapElement from './MapElement';
import RegularShape from 'ol/style/RegularShape';

import * as olExtent from 'ol/extent';

export default class MapRBPProduction extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);
    }

    initializeSelect() {
        super.initializeSelect();
        this.selectInteraction.style_ = function (ft, res) {
            if (ft.get('point')) return [new Style({
                image: new RegularShape({
                    fill: new Fill({
                        color: [0, 153, 255, 1],
                    }),
                    stroke: new Stroke({
                        color: [0, 153, 255, 1],
                        width: 1
                    }),
                    points: 4,
                    radius: 8,
                    radius2: 0,
                    angle: Math.PI / 4,
                }),
            }), new Style()];

            return [
                new Style({
                    stroke: new Stroke({
                        color: [255, 255, 255, 1],
                        width: 5
                    }),
                    zIndex: 1
                }),
                new Style({
                    stroke: new Stroke({
                        color: [0, 153, 255, 1],
                        width: 3
                    }),
                    zIndex: 1
                })
            ];
        };
    }

    SelectFeatureFromList(id) {
        var selectedFeature = this.layer.getSource().getFeatures().find(feature => { return feature.values_.name == id });

        this.selectInteraction.getFeatures().clear();
        if (selectedFeature) {
            this.selectInteraction.getFeatures().push(selectedFeature);
        }

        // Zoom to feature keeping current zoomlevel
        const center = olExtent.getCenter(selectedFeature.getGeometry().getExtent());

        const size = this.mapModel.map.getSize();

        const topLeftCoords = this.mapModel.map.getCoordinateFromPixel([0, 0]);
        const botRightCoords = this.mapModel.map.getCoordinateFromPixel([size[0], size[1]]);

        const offset1 = (botRightCoords[0] - topLeftCoords[0]) / 6
        const offset2 = (botRightCoords[1] - topLeftCoords[1]) / 6

        const view = this.mapModel.map.getView();

        view.animate({
            center: [center[0] - offset1, center[1] + offset2],
            duration: 100 // duration in milliseconds
        });
    }

    drawLayer(projection) {
        this.clear();

        const pointStyle = [new Style({
            image: new RegularShape({
                fill: new Fill({
                    color: 'red'
                }),
                stroke: new Stroke({
                    color: 'red',
                    width: 1
                }),
                points: 4,
                radius: 8,
                radius2: 0,
                angle: Math.PI / 4,
            }),
        }), new Style()];

        const lineStyle = new Style({
            stroke: new Stroke({
                color: "red",
                width: 3
            }),
        });

        this.featureDrawer = new FeatureDrawer(projection, this.mapModel.projection);
        const style = function (ft, res) {
            if (ft.get('point')) {
                return pointStyle
            } else
                return lineStyle
        }

        this.source = new VectorSource();
        this.layer = new VectorLayer({
            source: this.source,
            style: style,
            zIndex: 5
        });

        this.parent.layer.getLayers().push(this.layer);

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }

    addSteeringlines(data) {
        const features = []
        for (const key in data) {
            const value = data[key];
            const polyLinePoints = [];

            value.forEach((vertex) => {
                polyLinePoints.push({ x: vertex.xspray, y: vertex.yspray });
            });
            const feature = this.featureDrawer.drawFeature({ type: "POLYLINE", vertices: polyLinePoints });
            feature.set("name", key);
            features.push(feature);
        }
        this.source.addFeatures(features);
    }

    addSprayPoints(data) {
        const features = []
        for (const key in data) {
            const value = data[key];

            value.forEach(point => {
                const feature = this.featureDrawer.drawFeature({ type: "POINT", x: point.xspray, y: point.yspray });
                feature.set("name", point.rptimepositionId);
                feature.set("point", true);
                features.push(feature);
            })
        }
        this.source.addFeatures(features);
    }
}